export default __webpack_public_path__ + "static/media/ozon-hd.89145bbc.webp";